// extracted by mini-css-extract-plugin
export default {"ol-popup":"RobotsLayerPopup_ol-popup__IP7mI","ol-popup-closer":"RobotsLayerPopup_ol-popup-closer__7yxH0"};